
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import { handleKeyDown } from '../../../util/utils'

class DestinationCraneMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
    }
  }

  submitDestinationCrane (values) {
    const body = {
      ...values
    }
    this.props.actions.putDestinationCraneItem(body)
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      destinationCrane,
      combos: { UOTreeCombo }
    } = this.props
    const tKey = 'MASTERS.DESTINATION_CRANE_MASTER.MODAL.'
    return (
      <Modal id="destinationCraneMasterModal" className="_nf" show={showModal} onHide={this.props.actions.fetchDestinationCraneItem} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDestinationCrane.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.fetchDestinationCraneItem}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
              />
              <Field
                component={InputTreeSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                multi={false}
                allowClear={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                disabled={destinationCrane?.destinationCraneId !== null && destinationCrane?.destinationCraneId !== undefined}
              />

            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editDestinationCrane',
  validate: (values, props) => {
    const error = { }
    if (values) {
      const tKey = 'MASTERS.DESTINATION_CRANE_MASTER.VALIDATION.'
      if (!values.name || values.name === '' || values.name === ' ') {
        error.name = props.t(`${tKey}NAME`)
      }
      if (!values.description || values.description === '' || values.description === ' ') {
        error.description = props.t(`${tKey}DESCRIPTION`)
      }
      if (!values.organizedUnitId) {
        error.organizedUnitId = props.t(`${tKey}ORGANIZED_UNIT`)
      }
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(DestinationCraneMasterModal)
